function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 16,
  width: 300,
  height: 87,
  rx: 10,
  fill: "#F45D58"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M153.944 89.264C155.011 89.264 155.87 89.584 156.52 90.224C157.182 90.864 157.512 91.8133 157.512 93.072V98H155.016V93.456C155.016 92.7733 154.867 92.2667 154.568 91.936C154.27 91.5947 153.838 91.424 153.272 91.424C152.643 91.424 152.142 91.6213 151.768 92.016C151.395 92.4 151.208 92.976 151.208 93.744V98H148.712V86.128H151.208V90.288C151.539 89.9573 151.939 89.7067 152.408 89.536C152.878 89.3547 153.39 89.264 153.944 89.264ZM167.891 93.728C167.891 93.76 167.875 93.984 167.843 94.4H161.331C161.448 94.9333 161.725 95.3547 162.163 95.664C162.6 95.9733 163.144 96.128 163.795 96.128C164.243 96.128 164.637 96.064 164.979 95.936C165.331 95.7973 165.656 95.584 165.955 95.296L167.283 96.736C166.472 97.664 165.288 98.128 163.731 98.128C162.76 98.128 161.901 97.9413 161.155 97.568C160.408 97.184 159.832 96.656 159.427 95.984C159.021 95.312 158.819 94.5493 158.819 93.696C158.819 92.8533 159.016 92.096 159.411 91.424C159.816 90.7413 160.365 90.2133 161.059 89.84C161.763 89.456 162.547 89.264 163.411 89.264C164.253 89.264 165.016 89.4453 165.699 89.808C166.381 90.1707 166.915 90.6933 167.299 91.376C167.693 92.048 167.891 92.832 167.891 93.728ZM163.427 91.152C162.861 91.152 162.387 91.312 162.003 91.632C161.619 91.952 161.384 92.3893 161.299 92.944H165.539C165.453 92.4 165.219 91.968 164.835 91.648C164.451 91.3173 163.981 91.152 163.427 91.152ZM169.142 86.128H171.638V98H169.142V86.128ZM178.633 89.264C179.433 89.264 180.158 89.4507 180.809 89.824C181.47 90.1867 181.987 90.704 182.361 91.376C182.734 92.0373 182.921 92.8107 182.921 93.696C182.921 94.5813 182.734 95.36 182.361 96.032C181.987 96.6933 181.47 97.2107 180.809 97.584C180.158 97.9467 179.433 98.128 178.633 98.128C177.534 98.128 176.67 97.7813 176.041 97.088V101.104H173.545V89.392H175.929V90.384C176.547 89.6373 177.449 89.264 178.633 89.264ZM178.201 96.08C178.841 96.08 179.363 95.8667 179.769 95.44C180.185 95.0027 180.393 94.4213 180.393 93.696C180.393 92.9707 180.185 92.3947 179.769 91.968C179.363 91.5307 178.841 91.312 178.201 91.312C177.561 91.312 177.033 91.5307 176.617 91.968C176.211 92.3947 176.009 92.9707 176.009 93.696C176.009 94.4213 176.211 95.0027 176.617 95.44C177.033 95.8667 177.561 96.08 178.201 96.08Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M177.985 28.4937C174.644 26.1646 170.447 25 165.395 25C161.553 25 158.308 25.8189 155.673 27.4594C151.491 30.0266 149.27 34.3873 149 40.5359H158.692C158.692 38.7423 159.234 37.0224 160.313 35.3563C161.394 33.6959 163.229 32.8657 165.817 32.8657C168.449 32.8657 170.263 33.5401 171.25 34.886C172.244 36.2375 172.739 37.7308 172.739 39.3685C172.739 40.7966 172.001 42.1028 171.107 43.2872C170.574 44.0225 169.92 44.6677 169.17 45.1969C169.17 45.1969 163.915 48.4554 161.608 51.0736C160.272 52.5895 160.152 54.8647 160.031 58.1232C160.026 58.3556 160.116 58.8373 160.955 58.8373H168.49C169.24 58.8373 169.395 58.3017 169.404 58.0609C169.457 56.8765 169.592 56.2673 169.817 55.5816C170.239 54.2867 171.394 53.159 172.687 52.1843L175.354 50.4077C177.763 48.5914 179.682 47.1039 180.532 45.9365C181.98 44.0211 183 41.6579 183 38.8528C182.997 34.2768 181.327 30.8284 177.985 28.4937V28.4937ZM165.239 64.4532C161.901 64.354 159.146 66.5896 159.041 70.0918C158.938 73.5883 161.555 75.9032 164.897 75.9967C168.381 76.0959 171.063 73.9368 171.171 70.4346C171.271 66.9325 168.727 64.5524 165.239 64.4532V64.4532Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dd",
  x: 0,
  y: 0,
  width: 332,
  height: 119,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -4,
  dy: -4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 4,
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow",
  result: "effect2_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow",
  result: "shape"
})));

var SvgHelpBtn = function SvgHelpBtn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 119,
    viewBox: "0 0 332 119",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelpBtn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help-btn.87deecb5.svg";
export { ForwardRef as ReactComponent };